import { render, staticRenderFns } from "./StudentGender.vue?vue&type=template&id=2314d5d4&"
import script from "./StudentGender.js?vue&type=script&lang=js&"
export * from "./StudentGender.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports